<div class="combobox">
  <label for="{{ id }}" class="label-component">{{ label }}</label>
	<input id="{{ id }}" type="text" [(ngModel)]="inputItem" (ngModelChange)="getFilteredList()" class="combobox-input" (keyup)="onKeyPress($event)" (blur)="toggleListDisplay(0)" (focus)="toggleListDisplay(1)" placeholder="Selecione...">
  <!-- <span *ngIf="showError" class="error-text"><i>Invalid Selection.</i></span> -->
  <div class="combobox-options" *ngIf="!listHidden">
    <list-item *ngFor="let item of filteredList;let i = index" (click)="selectItem(i)" [ngClass]="{'selected': i===selectedIndex}">{{item}}</list-item>
  </div>
</div>